// extracted by mini-css-extract-plugin
export default {"leftSideBtn":"ViewButtons_leftSideBtn__M39GV","leftSideBtnContainer":"ViewButtons_leftSideBtnContainer__S79fG","rightSideBtn":"ViewButtons_rightSideBtn__bDV4X"};